import {omneticApi} from '@dms/api/base';

import {
  CreateInsuranceDraftApiArg,
  CreateInsuranceDraftApiArgSchema,
  CreateInsuranceDraftApiResponse,
  GetInsuranceSpecificationsApiArg,
  GetInsuranceSpecificationsApiResponse,
  InsuranceSpecificationsResponseBodySchema,
  GetInsuranceSpecificationsApiArgSchema,
  CreateInsuranceDraftResponseBodySchema,
} from './types';

export const businessCaseInsuranceApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    createInsuranceDraft: build.mutation<
      CreateInsuranceDraftApiResponse,
      CreateInsuranceDraftApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/business-case/${queryArg.businessCaseId}/create-insurance-draft`,
        method: 'POST',
      }),
      extraOptions: {
        requestSchema: CreateInsuranceDraftApiArgSchema,
        responseSchema: CreateInsuranceDraftResponseBodySchema,
      },
    }),
    getInsuranceSpecifications: build.query<
      GetInsuranceSpecificationsApiResponse,
      GetInsuranceSpecificationsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/business-case/${queryArg.businessCaseId}/insurance-specifications`,
      }),
      extraOptions: {
        requestSchema: GetInsuranceSpecificationsApiArgSchema,
        responseSchema: InsuranceSpecificationsResponseBodySchema,
      },
    }),
  }),
  overrideExisting: false,
});

export const {useCreateInsuranceDraftMutation, useGetInsuranceSpecificationsQuery} =
  businessCaseInsuranceApi;
